// Credit: https://github.com/remarkjs/react-remark/blob/main/src/index.ts#L29
// This is basically a simplified version of this but duplicated so we could
// directly leverage latest packages
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGFM from 'remark-gfm';
import remarkRehype from 'remark-rehype';
import rehypeMdxCodeProps from 'rehype-mdx-code-props';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import rehypeReact, { Options as RehypeReactOptions } from 'rehype-react';
import { createElement, Fragment } from 'react';
import { Root } from 'rehype-stringify/lib';
import getMarkdownComponents from '../constants/getMarkdownComponents';

export type TCompileTree = Root;

const getMarkdownProcessor = ({
  onAnchorClickLoggedParams,
}: {
  onAnchorClickLoggedParams: Record<string, string>;
}) => {
  // NOTE (@mbae, 05/30/24): React 18 migration, couldn't figure out why this type was complaining
  const options: RehypeReactOptions = {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    createElement,
    Fragment,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    components: getMarkdownComponents({ onAnchorClickLoggedParams }),
  };

  // unified returns a frozen processor; initialize unified per instance of getMarkdownProcessor
  return unified()
    .use(remarkParse)
    .use(remarkGFM)
    .use(remarkRehype)
    .use(rehypeMdxCodeProps)
    .use(rehypeRaw)
    .use(rehypeSanitize)
    .use(rehypeReact, options);
};

export default getMarkdownProcessor;
